import React, { useState, useEffect } from 'react';
import { Fade, IconButton, Menu, MenuItem, Tooltip } from '@mui/material';
import { useLanguage } from 'Context/LanguageContext';
import RoleUtils from 'FielderUtils/roles/roleUtils';
import AddUserModals from './AddUserModals';
import { PersonAdd } from '@mui/icons-material';
const TopMenuAddUser = ({ history, user }) => {
  const lan = useLanguage();
  const [anchor, setAnchor] = useState(null);
  const [show, setShow] = useState(true);
  const [showModal, setShowModal] = useState({
    newAdministrator: false,
    newManager: false,
    newClient: false,
    newAgent: false,
    newBranch: false,
  });
  const menuOpen = Boolean(anchor);
  useEffect(() => {
    const isNotClientOrGlobalUser = !(
      RoleUtils.isRootGlobalAccountUser(user) ||
      RoleUtils.isClientGlobalAccountUser(user) ||
      RoleUtils.isUserClient(user)
    );

    setShow(isNotClientOrGlobalUser);
  }, [user]);

  const hideModals = () => {
    setShowModal({
      newAdministrator: false,
      newManager: false,
      newClient: false,
      newAgent: false,
      newBranch: false,
    });
  };
  const handleOpenMenu = (e) => {
    setAnchor(e.currentTarget);
  };
  const handleClose = () => {
    setAnchor(null);
  };
  const handleShowModals = (modal) => () => {
    handleClose();
    setShowModal((prev) => ({ ...prev, [modal]: true }));
  };
  const AddUserMenu = () => {
    const addUserItems = ['newAdministrator', 'newManager', 'newAgent','newClient', 'newBranch'];
    if (RoleUtils.isUserManager(user)) {
      addUserItems.splice(0, 3);
    }
    const MenuItems = addUserItems.map((item) => (
      <MenuItem id={`TopMenuDropdown-${item}`} key={`TopMenuDropdown-${item}`} onClick={handleShowModals(item)}>
        {lan[item]}
      </MenuItem>
    ));
    return (
      <Menu id='TopMenuAddUser-Menu' anchorEl={anchor} open={menuOpen} onClose={handleClose} TransitionComponent={Fade}>
        {MenuItems}
      </Menu>
    );
  };
  return (
    <>
      {show && (
        <>
          <Tooltip arrow title={lan.addUser}>
            <IconButton
              aria-haspopup="true"
              aria-controls={menuOpen ? 'TopMenuAddUser-Menu' : undefined}
              aria-expanded={menuOpen ? 'true' : undefined}
              onClick={handleOpenMenu}
              sx={{
                p: 0,
                color: 'text.secondary',
                transition: (theme) => theme.transitions.create('color'),
                '&:hover': {
                  backgroundColor: 'transparent',
                  color: 'primary.main',
                },
              }}
            >
              <PersonAdd fontSize="medium" />
            </IconButton>
          </Tooltip>
          <AddUserMenu />
          <AddUserModals history={history} showModal={showModal} hideModals={hideModals} />
        </>
      )}
    </>
  );
};

export default TopMenuAddUser;
//Original code:
/*import React, { useState, useEffect } from 'react';
import { Fade, IconButton, Menu, MenuItem, Tooltip } from '@mui/material';
import { useLanguage } from 'Context/LanguageContext';
import RoleUtils from 'FielderUtils/roles/roleUtils';
import AddUserModals from './AddUserModals';
import { PersonAdd } from '@mui/icons-material';
import { FielderHard } from '@core/theme/baseTheme';
const TopMenuAddUser = ({ history, user }) => {
	const lan = useLanguage();
	const [anchor, setAnchor] = useState(null);
	const [show, setShow] = useState(true);
	const [showModal, setShowModal] = useState({
		newAdministrator: false,
		newManager: false,
		newClient: false,
		newAgent: false,
		newBranch: false,
	});
	const menuOpen = Boolean(anchor);
	useEffect(() => {
		const isNotClientOrGlobalUser = !(
			RoleUtils.isRootGlobalAccountUser(user) ||
			RoleUtils.isClientGlobalAccountUser(user) ||
			RoleUtils.isUserClient(user)
		);

		setShow(isNotClientOrGlobalUser);
	}, [user]);

	const hideModals = () => {
		setShowModal({
			newAdministrator: false,
			newManager: false,
			newClient: false,
			newAgent: false,
			newBranch: false,
		});
	};
	const handleOpenMenu = (e) => {
		setAnchor(e.currentTarget);
	};
	const handleClose = () => {
		setAnchor(null);
	};
	const handleShowModals = (modal) => () => {
		handleClose();
		setShowModal({ ...showModal, [modal]: true });
	};
	const AddUserMenu = () => {
		const addUserItems = ['newAdministrator', 'newManager', 'newAgent','newClient', 'newBranch'];
		if (RoleUtils.isUserManager(user)) {
			addUserItems.splice(0, 3);
		}
		const MenuItems = addUserItems.map((item) => (
			<MenuItem id={`TopMenuDropdown-${item}`} key={`TopMenuDropdown-${item}`} onClick={handleShowModals(item)}>
				{lan[item]}
			</MenuItem>
		));
		return (
			<Menu id='TopMenuAddUser-Menu' anchorEl={anchor} open={menuOpen} onClose={handleClose} TransitionComponent={Fade}>
				{MenuItems}
			</Menu>
		);
	};
	return (
		<>
			{show && (
				<>
          <Tooltip arrow title={lan.addUser}>
            <IconButton
              onClick={handleOpenMenu}
              sx={{
                p: 0,
                '& .top-menu-icon': {
                  color: 'text.disabled',
                },
                '&:hover .top-menu-icon': {
                  color: FielderHard,
                },
              }}
            >
              <PersonAdd fontSize="medium" className="top-menu-icon"/>
            </IconButton >
          </Tooltip>
          <AddUserMenu />
          <AddUserModals history={history} showModal={showModal} hideModals={hideModals} />
				</>
			)}
		</>
	);
};
export default TopMenuAddUser;
*/
